<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <validation-observer
              ref="checkExaminationFormRef"
              #default="{invalid}"
            >
              <b-form>
                <b-row>
                  <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                      label="Đợt xét tuyển"
                      label-for="admissionRound"
                    >
                      <v-select
                        id="admissionRound"
                        v-model="filter.admissionRoundId"
                        :options="admissionRounds"
                        :reduce="option => option.value"
                        :clearable="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                      label="Phương thức xét tuyển"
                      label-for="admissionForm"
                    >
                      <v-select
                        id="admissionForm"
                        v-model="filter.admissionFormId"
                        :options="admissionForms"
                        :reduce="option => option.value"
                        :clearable="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="4" lg="4" xl="4"
                  >
                    <b-form-group
                      label="Phòng thi"
                      label-for="admissionExaminationRoom"
                    >
                      <v-select
                        id="admissionExaminationRoom"
                        v-model="filter.admissionExaminationRoomId"
                        label="name"
                        :options="admissionExaminationRooms"
                        :reduce="option => option.id"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="4" lg="4" xl="4" v-show="false">
                    <b-form-group
                      label="Số báo danh"
                      label-for="bibNumber"
                    >
                      <b-form-input
                        id="Số báo danh"
                        v-model="filter.bibNumber"
                        name="bibNumber"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                      label="Trạng thái"
                      label-for="status"
                    >
                      <v-select
                        id="status"
                        v-model="filter.status"
                        :options="statusOptions"
                        :reduce="option => option.value"
                        :clearable="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="4" lg="4" xl="4">
                    <div class="mt-2 justify-content-center">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="mr-1"
                        @click="getDataSourcesFromStore"
                      >
                        <span class="text-nowrap text-right">
                          <feather-icon icon="SearchIcon" /> Tìm kiếm
                        </span>
                      </b-button>

                      <b-button
                        v-show="checkExaminationPaperCreatable"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="success"
                        :disabled="dataSources.length === 0"
                        @click="onSave"
                      >
                        <span class="text-nowrap text-right">
                          <feather-icon icon="CheckIcon" /> Lưu điểm
                        </span>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
                <b-row>

                </b-row>
                <b-row class="mt-2">
                  <b-col cols="12">
                    <vue-good-table
                      :columns="columns"
                      :rows="dataSources"
                      :pagination-options="paginationOptions"
                      :line-numbers="true"
                    >
                      <div
                        slot="emptystate"
                        style="text-align: center; font-weight: bold"
                      >
                        Không có bản ghi nào !
                      </div>

                      <template
                        slot="table-row"
                        slot-scope="props"
                      >
                        <template v-if="props.row.status === inProgressCheckExamination">
                          <span v-if="props.column.field === 'newScore'">
                            <validation-provider
                              #default="{ errors }"
                              name="Điểm"
                              rules="required|between:0,10"
                            >
                              <b-form-input
                                v-model.number="props.row.newScore"
                                type="number"
                                :state="getElementState(errors)"
                                @change="changeCell(props.row.newScore, props.column.field, props.row.originalIndex)"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </span>
                          <span v-else-if="props.column.field === 'examinerOne'">
                            <validation-provider
                              #default="{ errors }"
                              name="Giám khảo 1"
                              rules="required"
                            >
                              <Select2
                                v-model="props.row.examinerOne"
                                :options="teacherOptions"
                                @change="changeCell(props.row.examinerOne, props.column.field, props.row.originalIndex)"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </span>
                          <span v-else-if="props.column.field === 'examinerTwo'">
                            <validation-provider
                              #default="{ errors }"
                              name="Giám khảo 2"
                              rules="required"
                            >
                              <Select2
                                v-model="props.row.examinerTwo"
                                :options="teacherOptions"
                                @change="changeCell(props.row.examinerTwo, props.column.field, props.row.originalIndex)"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </span>
                          <span v-else-if="props.column.field === 'note'">
                            <b-form-input
                              v-model="props.row.note"
                              @change="changeCell(props.row.note, props.column.field, props.row.originalIndex)"
                            />
                          </span>
                          <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                        </template>
                        <span v-else-if="props.column.field === 'examinerOne'">
                          {{ getTeacherById(props.row.examinerOne) }}
                        </span>
                        <span v-else-if="props.column.field === 'examinerTwo'">
                          {{ getTeacherById(props.row.examinerTwo) }}
                        </span>
                        <!-- Column: Common -->
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>

                      <!-- pagination -->
                      <template
                        slot="pagination-bottom"
                        slot-scope="props"
                      >
                        <div class="d-flex justify-content-between flex-wrap">
                          <div class="d-flex align-items-center mb-0 mt-1">
                            <span class="text-nowrap"> Hiển thị 1 đến </span>
                            <b-form-select
                              v-model="itemsPerPage"
                              :options="itemsPerPageOptions"
                              class="mx-1"
                              @input="(value) => props.perPageChanged({ currentPerPage: value })"
                            />
                            <span class="text-nowrap">của {{ dataSources.length }} bản ghi</span>
                          </div>
                          <div>
                            <b-pagination
                              :value="1"
                              :total-rows="props.total"
                              :per-page="itemsPerPage"
                              class="mt-1 mb-0"
                              @input="(value) => props.pageChanged({ currentPage: value })"
                            />
                          </div>
                        </div>
                      </template>
                    </vue-good-table>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
  BForm,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import '@core/scss/vue/libs/vue-good-table.scss'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getUser } from '@/auth/utils'
import vSelect from 'vue-select'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { between, required } from '@validations'
import Select2 from 'v-select2-component'
import { CHECK_EXAMINATION_PAPERS } from '@/const/status'
import { Flag } from '@/const/flag'

export default {
  name: 'CheckExaminationPaper',
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BForm,
    BFormGroup,
    BFormInput,
    VueGoodTable,
    vSelect,
    ValidationObserver,
    ValidationProvider,
    Select2,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        trainingSystemId: null,
        admissionRoundId: null,
        admissionFormId: null,
        admissionExaminationRoomId: null,
        bibNumber: null,
        status: Flag.IN_PROGRESS_CHECK_EXAMINATION,
        isSeparate: null,
      },
      inProgressCheckExamination: Flag.IN_PROGRESS_CHECK_EXAMINATION,
      itemsPerPage: 20,
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'Phương thức xét tuyển',
          field: 'admissionFormName',
          thClass: 'text-center',
        },
        {
          label: 'Họ và tên',
          field: 'fullName',
          thClass: 'text-center',
        },
        {
          label: 'Môn thi',
          field: 'subjectName',
          thClass: 'text-center',
        },
        {
          label: 'Điểm cũ',
          field: 'oldScore',
          width: '10%',
          thClass: 'text-center',
        },
        {
          label: 'Điểm mới',
          field: 'newScore',
          width: '10%',
          thClass: 'text-center',
        },
        {
          label: 'Giám khảo một',
          field: 'examinerOne',
          thClass: 'text-center',
        },
        {
          label: 'Giám khảo hai',
          field: 'examinerTwo',
          thClass: 'text-center',
        },
        {
          label: 'Ghi chú',
          field: 'note',
          thClass: 'text-center',
        },
      ],
      required,
      between,
    }
  },
  computed: {
    ...mapGetters({
      teachers: 'teacher/teachers',
      admissionRounds: 'admissionRound/admissionRoundsByOrganization',
      admissionForms: 'admissionForm/admissionFormByAdmissionRoundId',
      admissionExaminationRooms: 'admissionExaminationRoom/examinationRooms',
      dataSources: 'applicantStudentExaminationRoom/checkExaminationDataSources'
    }),
    paginationOptions() {
      return {
        enabled: true,
        perPage: this.itemsPerPage,
      }
    },
    checkExaminationPaperCreatable() {
      return (isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.CHECK_EXAMINATION_PAPER))
        && this.filter.status === Flag.IN_PROGRESS_CHECK_EXAMINATION
    },
    teacherOptions() {
      return this.teachers.map(element => ({ id: element.id, text: element.name }))
    },

    statusOptions() {
      return CHECK_EXAMINATION_PAPERS
    },


    isSeparateRoom() {
      if (!this.filter.subjectCode) return null
      return this.filter.subjectCode.includes('_THCLASS_') ? 1 : 0
    },
  },
  watch: {
    'filter.admissionRoundId': async function (val) {
      await this.onChangeRoundId(val || this.filter.admissionRoundId)

    },
    'filter.admissionFormId': async function (val) {
      await this.getAdmissionExaminationRooms({
        admissionRoundId: this.filter.admissionRoundId,
        admissionFormId: val,
        currentPage: 1,
        itemsPerPage: 1000
      })
    },
    'filter.status': async function (val) {
      // await this.getDataSourcesFromStore()
    },
  },
  async created() {
    await this.getAdmissionRoundsByOrganization({organizationId: this.user.orgId})
    if (this.admissionRounds.length > 0) {
      this.filter.admissionRoundId = this.admissionRounds[0].value
    }
    this.isLoading = true
    try {
      await Promise.all([
        this.getTeachersByOrganizationId({ organizationId: this.user.orgId }),
        // this.getTrainingSystemsByOrganizationId({ organizationId: this.user.orgId }),
      ])
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
      getCheckExaminationPapers: 'applicantStudentExaminationRoom/getCheckExaminationPapers',
      createCheckExaminationPaper: 'applicantStudentExaminationRoom/createCheckExaminationPaper',
      getTeachersByOrganizationId: 'teacher/getTeachersByOrganizationId',
      getAdmissionRoundsByOrganization: 'admissionRound/readAdmissionRoundsByOrganization',
      readAdmissionFormByAdmissionRoundId: 'admissionForm/readAdmissionFormByAdmissionRoundId',
      getAdmissionExaminationRooms: 'admissionExaminationRoom/getAdmissionExaminationRooms',
    }),
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onChangeRoundId(roundId){
      await this.readAdmissionFormByAdmissionRoundId({admissionRoundId: roundId})
      if (this.admissionForms.length > 0) {
        this.filter.admissionFormId = this.admissionForms[0].value
      }
    },
    async getDataSourcesFromStore() {
      this.isLoading = true
      try {
        await this.getCheckExaminationPapers(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    changeCell(data, column, row) {
      this.dataSources[row][column] = data
    },

    async onSave() {
      const valid = await this.$refs
        .checkExaminationFormRef
        .validate()
      if (valid) {
        const checkExaminationPapers = this.dataSources.map(element => ({
          applicantStudentExaminationRoomId: element.applicantStudentExaminationRoomId,
          oldScore: element.oldScore,
          newScore: element.newScore,
          examinerOne: element.examinerOne,
          examinerTwo: element.examinerTwo,
          note: element.note,
          applicantCheckExaminationId: element.applicantCheckExaminationId,
          logAdmissionCheckExaminationId: element.logAdmissionCheckExaminationId,
        }))
        this.isLoading = true
        try {
          const { isSuccessful, message } = await this.createCheckExaminationPaper({ checkExaminationPapers })
          if (isSuccessful) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            await this.getDataSourcesFromStore()
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },

    getTeacherById(id) {
      if (!id || this.teachers.length === 0) return ''
      const found = this.teachers.find(teacher => teacher.id === id)
      return found ? found.name : ''
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
